import _ from 'lodash';
import React, { useState } from 'react';
import { Table } from 'semantic-ui-react';

interface TableHeaderPropTypes {
  columnNames: string[];
  sortedData: any[];
  setSortedData: (sortedData: any[]) => void;
}

export const TableHeader = (props: TableHeaderPropTypes) => {
  interface SortInfo {
    columnName: string;
    direction: 'ascending' | 'descending';
  }

  const initialSortInfo: SortInfo = {
    columnName: '',
    direction: 'ascending',
  };

  const [columnSortInfo, setColumnSortInfo] = useState<SortInfo>(initialSortInfo);

  const onSortChangeClick = (columnName: string) => {
    const currentColumnName = columnSortInfo.columnName;
    const currentDirection = columnSortInfo.direction;

    if (currentColumnName === columnName) {
      props.setSortedData(props.sortedData.slice().reverse());
    } else {
      const objectKeys = Object.keys(props.sortedData[0]);
      const columnNameLower = columnName.replace(/ /g, '').toLowerCase();
      const objectFieldName =
        objectKeys.find(k => k.toLowerCase() === columnNameLower) ??
        objectKeys.find(k => columnNameLower.includes(k.toLowerCase())) ??
        objectKeys.find(k => k.toLowerCase().includes(columnNameLower)) ??
        (columnNameLower === 'primaryhousenumber'
          ? 'phn'
          : columnNameLower === 'buildingclass'
          ? 'bldgClass'
          : null);
      if (objectFieldName) {
        props.setSortedData(
          _.sortBy(props.sortedData, d =>
            typeof d[objectFieldName] === 'string'
              ? d[objectFieldName] == ''
                ? null
                : d[objectFieldName]?.toLowerCase()
              : d[objectFieldName]
          )
        );
      }
    }

    const newDirection =
      columnName === currentColumnName
        ? currentDirection === 'ascending'
          ? 'descending'
          : 'ascending'
        : 'ascending';

    setColumnSortInfo({
      columnName,
      direction: newDirection,
    });
  };
  return (
    <Table.Header>
      <Table.Row>
        {props.columnNames.map(c => {
          return (
            <Table.HeaderCell
              sorted={columnSortInfo.columnName === c ? columnSortInfo.direction : null}
              onClick={() => onSortChangeClick(c)}
            >
              {c}
            </Table.HeaderCell>
          );
        })}
      </Table.Row>
    </Table.Header>
  );
};
